import { getConfig } from '../config/config'
import side from '../../../util/side/side'

export const getAdapterApiUrl = (): string => {
  const { CLIENT_API_ADAPTER_URL, SERVER_API_ADAPTER_URL } = getConfig()
  return side() === 'client' ? CLIENT_API_ADAPTER_URL : SERVER_API_ADAPTER_URL
}
